// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2VLr7","bigColWidth":"Table_bigColWidth__1Zrsp","biggerColWidth":"Table_biggerColWidth__1dlcB","row":"Table_row__1JgWC","col":"Table_col__32E-b"};